import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import CustomScrollbar from 'components/Common/CustomScrollbar';
const GeneralTooltips = () => {
  const isMobile = useIsMobile();
  return (
    <>
      <ReactTooltip
        effect={'solid'}
        id={'tags-tooltip'}
        className={'tags-tooltip'}
        backgroundColor={'#00122B'}
        textColor={'#fff'}
        arrowColor={'transparent'}
        place={'top'}
        offset={5}
        delayShow={300}
        globalEventOff={isMobile ? 'click' : undefined}
      />
      <ReactTooltip
        effect={'solid'}
        id={'general-tooltip'}
        className={'header-tooltip'}
        arrowColor={'transparent'}
        place={'top'}
        globalEventOff={isMobile ? 'click' : undefined}
      />
      <ReactTooltip
        effect={'solid'}
        id={'tooltip-mobile'}
        className={'header-tooltip'}
        scrollHide={true}
        arrowColor={'transparent'}
        place={'top'}
      />
      <ReactTooltip
        effect={'solid'}
        id={'tooltip-mobile-clickable'}
        className={'header-tooltip'}
        scrollHide={true}
        arrowColor={'transparent'}
        place={'top'}
        clickable={true}
      />
      <ReactTooltip
        effect={'solid'}
        id={'clickeable-tooltip'}
        className={'contributions-tooltip'}
        arrowColor={'transparent'}
        place={'top'}
        clickable={true}
        globalEventOff={'click'}
        opacity={1}
      />
      <ReactTooltip
        effect={'solid'}
        id={'custom-field-item-tooltip'}
        className={'header-tooltip'}
        arrowColor={'transparent'}
        place={'top'}
        closeEvents={{ mouseleave: true, blur: true, click: true }}
        openEvents={{ mouseenter: true, focus: false }}
      />
      <ReactTooltip
        effect={'solid'}
        id={'scrollable-list-tooltip'}
        className={'header-tooltip scrollable-list-tooltip'}
        arrowColor={'transparent'}
        place={'top'}
        clickable={true}
        globalEventOff={isMobile ? 'click' : undefined}
        render={({ content }) => (
          // Each line is "name" or "name\turl" (url set → a clickable link opening in a new tab);
          // \t is used as the separator since it's an extremely unlikely character in a person's name.
          <CustomScrollbar
            autoHeight
            autoHeightMax={155}
            maximalThumbYSize={50}
            minimalThumbYSize={50}
            className='simple-scrollbar'
          >
            {content?.split('\n').map((line, index) => {
              const [name, url] = line.split('\t');
              return (
                <div key={index}>
                  {url ? (
                    <a href={url} target='_blank' rel='noreferrer'>
                      {name}
                    </a>
                  ) : (
                    name
                  )}
                </div>
              );
            })}
          </CustomScrollbar>
        )}
      />
    </>
  );
};

export default GeneralTooltips;
